import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

const defaultContext = {
  message: 'Please wait...',
  withBox: true,
};

@Component({
  selector: 'tcs-load-until',
  templateUrl: './load-until.component.html',
  styleUrls: ['./load-until.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadUntilComponent implements OnInit {
  @Input() public context: { message: string; withBox: boolean } = defaultContext;

  constructor() {}

  public ngOnInit() {
    this.context = { ...defaultContext, ...this.context };
  }
}
